import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.999 12.75h16a.75.75 0 1 0 0-1.5h-16a.75.75 0 1 0 0 1.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m14.554 7.604.003.002.01.007.04.03a32 32 0 0 1 .712.544c.462.361 1.077.854 1.688 1.385.616.535 1.212 1.094 1.649 1.588q.33.373.486.634c.068.113.093.179.102.206a1 1 0 0 1-.102.206 4.6 4.6 0 0 1-.486.635c-.437.494-1.033 1.052-1.648 1.587a43 43 0 0 1-2.4 1.929l-.04.03-.01.007-.003.002a.75.75 0 0 0 .889 1.208L14.999 17l.445.604.016-.012.044-.032a37 37 0 0 0 .738-.565c.475-.37 1.11-.88 1.749-1.435.634-.55 1.288-1.16 1.789-1.726a6 6 0 0 0 .647-.854c.157-.26.322-.607.322-.98 0-.374-.165-.72-.322-.98a6 6 0 0 0-.647-.854c-.501-.567-1.155-1.176-1.79-1.726a44 44 0 0 0-2.486-2l-.044-.032-.012-.009-.004-.003L15 7l.445-.604a.75.75 0 0 0-.89 1.208",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }